/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Inspection_Updated_HoldInputs */

const en_orders_inspection_updated_hold = /** @type {(inputs: Orders_Inspection_Updated_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspection updated and order moved to On Hold`)
};

const es_orders_inspection_updated_hold = /** @type {(inputs: Orders_Inspection_Updated_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspeccion actualizada y pedido movido a En espera`)
};

/**
* | output |
* | --- |
* | "Inspection updated and order moved to On Hold" |
*
* @param {Orders_Inspection_Updated_HoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_inspection_updated_hold = /** @type {((inputs?: Orders_Inspection_Updated_HoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Inspection_Updated_HoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_inspection_updated_hold(inputs)
	return es_orders_inspection_updated_hold(inputs)
});